import React from 'react'
import VisibilitySensor from '../VisibilitySensor'
import Content from './Content'
import { makeStyles } from '@material-ui/core/styles'
import ImageZoom from './ImageZoom'
import FadeInHOC from '../FadeInHOC'
import { SvoltaPageConfig } from '../../configuration'
import AssignId from '../AssignId'

export const styles = theme => ({
    root: {
        padding: '100px 158px',
        height: 'auto',
        position: 'relative',
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'stretch',
        flexDirection: 'column',
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1350)]: {
            padding: '98px 5rem'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 1185)]: {
            padding: '100px 2rem',
            justifyContent: 'center'
        },
        [theme.breakpoints.down(theme.breakpoints.values.xs + 760)]: {
            padding: '100px .8rem',
            justifyContent: 'center'
        }
    }
})

const useStyles = makeStyles(styles)

export default function Svolta() {
    const classes = useStyles()
    return (
        <div>
            <div className={classes.root}>
                <AssignId
                    absolute
                    y='-20px'
                    yMobile='10px'
                    id={SvoltaPageConfig.slug}
                />
                <FadeInHOC>
                    <Content
                        primaryText={SvoltaPageConfig.content.primary}
                        secondaryText={SvoltaPageConfig.content.secondary}
                    />
                </FadeInHOC>
                <VisibilitySensor index={3} />
                <ImageZoom url={SvoltaPageConfig.zoom.src} url_mobile={SvoltaPageConfig.zoom.src_mobile} />
            </div>
        </div>
    )
}
